import { type InputHTMLAttributes } from 'react'
import { type TextFieldProps } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'

// Native-input passthrough giữ lại để API tương thích với call site cũ
// (chỉ còn dùng cho tabIndex / aria-label) — map vào input của DatePicker.
type NativeDateInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'value' | 'onChange' | 'disabled'
>

type DateTextFieldProps = Omit<TextFieldProps, 'type' | 'value' | 'onChange'> & {
  value?: string | null
  onChange: (value: string) => void
  nativeInputProps?: NativeDateInputProps
}

/**
 * Date input dùng MUI `<DatePicker>` với format `DD-MMM-YYYY` — đồng bộ style/
 * popup lịch với mọi DatePicker khác trong app (vd Purchase Contract Date).
 * Giữ nguyên props API string in/out (`value` = ISO `YYYY-MM-DD`, `onChange`
 * trả về ISO string) để không phải sửa 16 call site đang dùng.
 */
export default function DateTextField({
  value,
  onChange,
  disabled,
  fullWidth,
  inputProps,
  InputLabelProps,
  nativeInputProps,
  sx,
  ...textFieldProps
}: DateTextFieldProps) {
  return (
    <DatePicker
      format="DD-MMM-YYYY"
      value={value ? dayjs(value) : null}
      onChange={(d) => onChange(d && d.isValid() ? d.format('YYYY-MM-DD') : '')}
      disabled={disabled}
      slotProps={{
        textField: {
          ...textFieldProps,
          fullWidth,
          sx,
          InputLabelProps: { ...InputLabelProps, shrink: true },
          inputProps: { ...inputProps, ...nativeInputProps },
        },
      }}
    />
  )
}
